<template>
  <div>
    <b-card
      v-if="orders && orders.length > 0"
      :title="cardTitle"
    >
      <b-table
        hover
        responsive
        :items="orders"
        :fields="fields"
        class="mb-0"
        show-empty
        empty-text="Aucune commande à afficher"
      >
        <template #cell(reference)="data">
          <router-link
            :to="{ name: 'order-show', params: { id: data.item.id }}"
            class="text-primary font-weight-bold"
          >
            {{ data.item.reference }}
          </router-link>
        </template>

        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.status)">
            {{ getStatusLabel(data.item.status) }}
          </b-badge>
        </template>

        <template #cell(amount)="data">
          {{ formatPrice(data.item.amount) }}
        </template>

        <template #cell(created_at)="data">
          {{ formatDate(data.item.created_at) }}
        </template>

        <template #cell(actions)="data">
          <router-link
            class="text-info mr-1"
            :to="{ name: 'order-show', params: { id: data.item.id } }"
          >
            <feather-icon
              icon="EyeIcon"
              class="cursor-pointer"
              size="16"
            />
          </router-link>
        </template>
      </b-table>

      <div
        v-if="showViewAllButton && totalOrders > orders.length"
        class="mt-2 text-right"
      >
        <b-button
          variant="outline-primary"
          size="sm"
          @click="viewAllOrders"
        >
          {{ viewAllText || 'Voir toutes les commandes' }}
        </b-button>
      </div>
    </b-card>

    <b-card
      v-else
      :title="cardTitle"
    >
      <div class="text-center">
        <p>Aucune commande à afficher</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BBadge, BButton,
} from 'bootstrap-vue'

export default {
  name: 'OrdersTable',
  components: {
    BCard,
    BTable,
    BBadge,
    BButton,
  },
  props: {
    orders: {
      type: Array,
      required: true,
    },
    totalOrders: {
      type: Number,
      default: 0,
    },
    cardTitle: {
      type: String,
      default: 'Dernières commandes',
    },
    showViewAllButton: {
      type: Boolean,
      default: true,
    },
    viewAllText: {
      type: String,
      default: 'Voir toutes les commandes',
    },
    entityId: {
      type: [Number, String],
      required: false,
      default: null, // Add default value to fix the warning
    },
    entityType: {
      type: String,
      validator: value => ['locality', 'delegation', 'governorate'].includes(value),
      default: 'locality',
    },
  },
  data() {
    return {
      fields: [
        { key: 'reference', label: 'Référence' },
        { key: 'client_name', label: 'Client' },
        { key: 'amount', label: 'Montant' },
        { key: 'status', label: 'État' },
        { key: 'created_at', label: 'Date' },
        { key: 'actions', label: 'Actions' },
      ],
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('fr-TN', {
        style: 'currency',
        currency: 'TND',
      }).format(price)
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return new Intl.DateTimeFormat('fr-TN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date)
    },
    getStatusVariant(status) {
      const statusMap = {
        'En Attente': 'warning',
        'En Pickup': 'info',
        'Colis au dépôt': 'info',
        'En cours': 'primary',
        Livré: 'success',
        'Retour au dépôt': 'danger',
        'Livré payé': 'success',
        'Retour au fournisseur': 'danger',
        'En Transfert': 'secondary',
        'Retour payé': 'danger',
        'Colis annulé par admin': 'danger',
        'Colis perdu': 'danger',
        'À vérifier': 'warning',
        Échange: 'warning',
        'Échange reçu': 'success',
        25: 'warning',
        26: 'success',
      }
      return statusMap[status] || 'secondary'
    },
    getStatusLabel(status) {
      const statusLabels = {
        25: 'Échange',
        26: 'Échange reçu',
      }
      return statusLabels[status] || status
    },
    viewAllOrders(event) {
      // Prevent default navigation
      if (event) {
        event.preventDefault()
      }

      // Just emit the event, let parent component handle the action
      this.$emit('view-all-orders')
    },
  },
}
</script>

<style scoped>
.table td {
  vertical-align: middle;
}
</style>
